import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import loadNamespaces from 'next-translate/loadNamespaces';
import { useIsMobile } from '../../style/constants';
import { Container } from '../../VuexyDesign/atoms/_index';
import FAQ from '../../components/HowItWorks/FAQ';
import JoinContestsHeroSection from '../../components/HowItWorks/JoinContestsHeroSection';
import BrowserPageTitle from '../../components/common/BrowserPageTitle';
import {
  HowItWorksRowDesktop,
  HowItWorksRowMobile,
} from '../../VuexyDesign/organisms/_index';
import { joinContests } from '../../components/HowItWorks/AccordionContent';
import { VirpPageContext } from '../_app';

const howTos = [
  {
    key: 1,
    headerTitle: 'howItWorks:howToJoinContests.headerTitle.connectWithLabels',
    title: 'howItWorks:howToJoinContests.exploreContests',
    subtitle: 'howItWorks:joinContestsDescriptions.exploreContests',
    media: '/static/animations/connect.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 2,
    headerTitle: 'howItWorks:howToJoinContests.headerTitle.remixContest',
    title: 'howItWorks:howToJoinContests.joinRemixContest',
    subtitle: 'howItWorks:joinContestsDescriptions.joinRemixContest',
    media: '/static/animations/remix.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 3,
    headerTitle: 'howItWorks:howToJoinContests.headerTitle.raffle',
    title: 'howItWorks:howToJoinContests.joinRaffle',
    subtitle: 'howItWorks:joinContestsDescriptions.joinRaffle',
    media: '/static/animations/raffle.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
  {
    key: 4,
    headerTitle: 'howItWorks:howToJoinContests.headerTitle.demoDrop',
    title: 'howItWorks:howToJoinContests.joinDemoDrop',
    subtitle: 'howItWorks:joinContestsDescriptions.joinDemoDrop',
    media: '/static/animations/demodrop.json',
    leftColumn: '6',
    rightColumn: '5',
    picture: true,
    videoLeft: true,
  },
  {
    key: 5,
    headerTitle: 'howItWorks:howToJoinContests.headerTitle.whatsNext',
    title: 'howItWorks:howToJoinContests.winner',
    subtitle: 'howItWorks:joinContestsDescriptions.selectAWinner',
    media: '/static/animations/trophy.json',
    leftColumn: '7',
    rightColumn: '5',
    picture: true,
    videoLeft: false,
  },
];

const Index = () => {
  const { t } = useTranslation('howItWorks');
  const isMobile = useIsMobile();

  return (
    <div className="d-flex w-100 justify-content-center align-items-center flex-column">
      <BrowserPageTitle>
        {t('howItWorks:howToJoinContests.title')}
      </BrowserPageTitle>
      <Container
        fluid
        className="d-flex align-items-center position-relative px-0"
      >
        <JoinContestsHeroSection />
      </Container>
      {howTos.map((howTo) =>
        isMobile ? (
          <HowItWorksRowMobile
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            picture={howTo.picture}
          />
        ) : (
          <HowItWorksRowDesktop
            key={howTo.key}
            headerTitle={howTo.headerTitle}
            title={howTo.title}
            subtitle={howTo.subtitle}
            media={howTo.media}
            leftColumn={howTo.leftColumn}
            rightColumn={howTo.rightColumn}
            videoLeft={howTo.videoLeft}
            picture={howTo.picture}
          />
        ),
      )}

      <FAQ page={joinContests} />
    </div>
  );
};

Index.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/how-it-works/join-contests',
  });
  return { ...getTranslations };
};

export default Index;
